const isSwappable = (playlistGraphic: PlaylistGraphic) =>
  playlistGraphic.status.live && playlistGraphic.graphic.config.isSwappable;

export { isSwappable };
